enum CookieEnum {
  refreshToken = 'refreshToken',
  sessionToken = 'SESSIONTOKEN',
  koloToken = 'koloToken',
  userTokenId = 'userToken.id',
  userTokenCustom = 'firebase.customToken',
  userTokenRefresh = 'userToken.refresh',
  userTokenSignature = 'userToken.sig',
  company = 'company',
  authToken = 'authToken',
  currentUser = 'currentUser',
}

const CookieExpirationHours = {
  [CookieEnum.userTokenId]: 1,
  [CookieEnum.userTokenCustom]: 1,
  [CookieEnum.userTokenRefresh]: 1,
  [CookieEnum.userTokenSignature]: 1,
  [CookieEnum.company]: 24,
  [CookieEnum.authToken]: 1,
  [CookieEnum.currentUser]: 24,
}

export { CookieEnum, CookieExpirationHours }
